/**
 * Friends API Client
 */

import { http } from './http';

export interface FriendRequest {
  id: string;
  fromWallet: string;
  fullFromWallet?: string;
  toWallet?: string;
  status?: string;
  createdAt: string;
}

export interface FriendActivity {
  id: string;
  wallet: string;
  type: 'match_won' | 'match_lost' | 'level_up' | 'rank_up' | 'achievement' | 'streak';
  data: Record<string, unknown>;
  createdAt: string;
}

export async function getFriends(wallet: string): Promise<{
  friends: string[];
  friendCount: number;
  pendingRequests: number;
  displayNames?: Record<string, string>;
}> {
  return http.get<{
    friends: string[];
    friendCount: number;
    pendingRequests: number;
    displayNames?: Record<string, string>;
  }>(`/friends/${wallet}`);
}

export async function getFriendRequests(
  wallet: string,
): Promise<{ pending: FriendRequest[]; sent: FriendRequest[] }> {
  return http.get<{ pending: FriendRequest[]; sent: FriendRequest[] }>(
    `/friends/${wallet}/requests`,
  );
}

export async function sendFriendRequest(
  fromWallet: string,
  toWallet: string,
): Promise<{ success: boolean; requestId?: string }> {
  return http.post<{ success: boolean; requestId?: string }>('/friends/request', {
    fromWallet,
    toWallet,
  });
}

export async function acceptFriendRequest(
  requestId: string,
  wallet: string,
): Promise<{ success: boolean }> {
  return http.post<{ success: boolean }>('/friends/accept', { requestId, wallet });
}

export async function declineFriendRequest(
  requestId: string,
  wallet: string,
): Promise<{ success: boolean }> {
  return http.post<{ success: boolean }>('/friends/decline', { requestId, wallet });
}

export async function removeFriend(
  wallet: string,
  friendWallet: string,
): Promise<{ success: boolean }> {
  return http.delete<{ success: boolean }>(`/friends/${wallet}/${friendWallet}`);
}

export async function getFriendsActivity(
  wallet: string,
  limit = 20,
): Promise<{ activity: FriendActivity[] }> {
  return http.get<{ activity: FriendActivity[] }>(`/friends/${wallet}/activity?limit=${limit}`);
}
